import { useEffect, useState } from "react";

import project1_1 from "../images/recruiting hire 01.jpg";
import project2_1 from "../images/fortuino1.png";
import project3_1 from "../images/perfumeProject.png";
import project4_1 from "../images/rock-paper1.png";
import project5_1 from "../images/sheikhMujib1.png";

import project1_2 from "../images/recruiting hire 02.jpg";
import project2_2 from "../images/fortuino2.png";
import project3_2 from "../images/perfumeProject2.png";
import project4_2 from "../images/rock-paper2.png";
import project5_2 from "../images/sheikhMujib2.png";

import project1_3 from "../images/recruiting hire 03.jpg";
import project2_3 from "../images/fortuino3.png";
import project3_3 from "../images/perfumeProject3.png";
import project4_3 from "../images/rock-paper3.png";
import project5_3 from "../images/sheikhMujib3.png";

const allProjects = [
  {
    id: 1,
    name: "Recruiting Hire",
    desc: "A fullstack redux based web platform for recruiting and job searching",
    image1: project1_1,
    image2: project1_2,
    image3: project1_3,
    stack: "fullstack",
    liveSite: "https://recruiting-hire.web.app/",
    clientCode: "https://github.com/mdsaharshital/Recruiting-Hire-client",
    serverCode: "https://github.com/mdsaharshital/recruiting-hire-server",
    techUsed: "React.js, Redux-toolkit, Express.js, MongoDB",
  },
  {
    id: 2,
    name: "Fortuino Manufacturer",
    desc: "A fullStack project for a wood manufacturer who sells their woods and furniture to small or big businesses.",
    image1: project2_1,
    image2: project2_2,
    image3: project2_3,
    stack: "fullstack",
    liveSite: "https://fortunio-timber.web.app/",
    clientCode: "https://github.com/mdsaharshital/wood-manufacturer-client",
    serverCode: "https://github.com/mdsaharshital/wood-manufacturer-server",
    techUsed: "React.js, Express.js, MongoDB",
  },
  {
    id: 3,
    name: "Perfume Warehouse",
    desc: "A fullStack inventory management system where an owner and his co-workers can easily manage their products.",
    image1: project3_1,
    image2: project3_2,
    image3: project3_3,
    stack: "fullstack",
    liveSite: "https://perfume-warehouse-17111.web.app/",
    clientCode:
      "https://github.com/mdsaharshital/perfume-warehouse-management-system-client",
    serverCode:
      "https://github.com/mdsaharshital/perfume-warehouse-management-system-server",
    techUsed: "React.js, Express.js, MongoDB",
  },
  {
    id: 4,
    name: "Rock paper scissor",
    desc: "This is the most famous game rock paper scissors. Fully developed by own logic in React js.",
    image1: project4_1,
    image2: project4_2,
    image3: project4_3,
    stack: "frontend",
    techUsed: "React.js, Tailwind CSS",
    liveSite: "https://rock-paper-scissior-by-shital.netlify.app/",
    clientCode: "https://github.com/mdsaharshital/rock-paper-scissors",
  },
  {
    id: 5,
    name: "Wildlife photographer",
    desc: "This is a frontend project for a photographer who wants to showcase his photography to the world",
    image1: project5_1,
    image2: project5_2,
    image3: project5_3,
    stack: "frontend",
    liveSite: "https://sheikh-mujib-photographer.netlify.app/",
    clientCode: "https://github.com/mdsaharshital/wild-photographer-react-auth",
    techUsed: "React.js, Firebase-auth, Bootstrap5,",
  },
];
const useProjects = () => {
  const [projects, setProject] = useState([]);
  useEffect(() => {
    setProject(allProjects);
  }, []);
  return [projects, setProject];
};
export default useProjects;
